module.exports = __webpack_public_path__ + "static/media/battery_3.efa0e36a.png";